/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthUserData } from '../../redux/features/auth/auth.slice';
import { postSignOutThunk } from '../../redux/features/auth/auth.thunk';

export default function useUserMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const userData = useSelector(selectAuthUserData);
  const dispatch = useDispatch();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = () => {
    handleClose();
    dispatch(postSignOutThunk());
  };

  const setImplementation = (implementation) => {
    handleClose();
    localStorage.setItem('implementation', implementation);
    window.location.reload();
  };

  return {
    userData,
    handleMenu,
    anchorEl,
    isOpen,
    handleClose,
    handleSignOut,
    setImplementation,
  };
}
